import { render, staticRenderFns } from "./optionDetail.vue?vue&type=template&id=2c32484c&scoped=true"
import script from "./optionDetail.vue?vue&type=script&lang=js"
export * from "./optionDetail.vue?vue&type=script&lang=js"
import style0 from "./optionDetail.vue?vue&type=style&index=0&id=2c32484c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c32484c",
  null
  
)

export default component.exports